import React from "react";
import { BeatLoader } from "react-spinners";
import "./../../css/GlobalLoader.css";

function GlobalLoader() {
  return (
    <div className="overlay">
      <BeatLoader color="#0f69c3" size={20} />
    </div>
  );
}

export default GlobalLoader;
